import { memo } from 'react';
import { Box } from '@alf/uikit';
import { ScoreDataType } from '../types';
import Column from './Column';

type ScoreDetailsProps = {
  scoreData: ScoreDataType[];
  isShortVersion: boolean;
  lineView: string;
};

const ScoreDetails = ({
  scoreData,
  isShortVersion,
  lineView
}: ScoreDetailsProps) => (
  <Box align="center" justify="center">
    {scoreData.map((scoreColumn, index) => {
      const key = `scoreColumn-${index}-${scoreColumn?.type}--${scoreColumn?.tag}`;
      return (
        <Column
          key={key}
          {...scoreColumn}
          isShortVersion={isShortVersion}
          lineView={lineView}
        />
      );
    })}
  </Box>
);

export default memo(ScoreDetails);
